import { render, staticRenderFns } from "./CheckoutEdit.vue?vue&type=template&id=84bf544e"
import script from "../../controllers/checkout/checkout-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/checkout/checkout-edit.js?vue&type=script&lang=js&external"
import style0 from "./CheckoutEdit.vue?vue&type=style&index=0&id=84bf544e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports